/**
 * Manage users data
 */
import Ajax from '@/lib/ajax_wrapper'

const ADMIN_USER_PATH = '/admin/users'
const USER_PATH = '/users'

/**
 * Create a user
 *
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function activateUser(user, token) {
  return Ajax.request({
    url: `${ADMIN_USER_PATH}/account_activation/${token}`,
    method: 'PATCH',
    data: {user}
  })
}

/**
 * Read paginated users
 *
 * @param {object} page
 * @param {integer} page.number
 * @param {integer} page.pePage
 *
 * @returns {promise}
 */
export function readUsersData(page) {
  return Ajax.request({
    url: ADMIN_USER_PATH,
    page: page
  })
}

/**
 * Create a user
 *
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function createUserData(user) {
  return Ajax.request({
    url: USER_PATH,
    method: 'POST',
    data: {user}
  })
}

/**
 * Create a public user
 *
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function createPublicUserData(user) {
  return Ajax.request({
    url: `${USER_PATH}/signup`,
    method: 'POST',
    data: {user}
  })
}

/**
 * Read a user
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readUserData(id) {
  return Ajax.request({
    url: `${ADMIN_USER_PATH}/${id}`
  })
}

/**
 * Update a user
 *
 * @param {string} id
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function updateUserData(id, user) {
  return Ajax.request({
    url: `${ADMIN_USER_PATH}/${id}`,
    method: 'PATCH',
    data: {user}
  })
}

/**
 * Delete a user
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteUserData(id) {
  return Ajax.request({
    url: `${ADMIN_USER_PATH}/${id}`,
    method: 'DELETE'
  })
}

/**
 * Start password reset process
 *
 * @returns {promise}
 */
export function initResetPassword(user) {
  return Ajax.request({
    url: '/admin/users/password_reset',
    data: {user},
    method: 'POST'
  })
}

/**
 * Reset user password
 *
 * @returns {promise}
 */
export function resetPassword(user) {
  return Ajax.request({
    url: '/admin/users/password_reset',
    data: {user},
    method: 'PATCH'
  })
}
